
import '../../sass/layout/sections/section-realizations.scss';

import Swiper from 'swiper';
import {Pagination, Autoplay, Navigation} from 'swiper/modules';

const swiperRealizations = document.getElementById('swiperRealizations');

if(swiperRealizations) {
    // const pagination = swiperRealizations.querySelector('.swiper-pagination');
    const prevEl = swiperRealizations.querySelector('.swiper-button-prev');
    const nextEl = swiperRealizations.querySelector('.swiper-button-next');
    const swiper = new Swiper(swiperRealizations, {
        modules: [Navigation, Autoplay],
        loop: false,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 18,
        // pagination: {
        //     el: pagination,
        // },
        autoplay: true,
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        breakpoints: {
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 25
            }
          }
    })  
    const slides = swiperRealizations.querySelectorAll('.swiper-realizations__slide');
    slides.forEach(el => {
        el.addEventListener('click', e => {
            window.location = el.querySelector('.btn').href;
        })
    })
}
